import React from 'react';
import { useNavigate } from 'react-router';
import styled from 'styled-components';
import { Alert, Button } from '@equinor/opt-ui-core';
import { Refresh } from '@equinor/opt-ui-icons';
const Container = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  color: whitesmoke;
`;
const ErrorPage = ({ isLogsEnabled = false }) => {
    const navigate = useNavigate();
    return (React.createElement(Container, null,
        React.createElement("h2", null, "Whoops!"),
        React.createElement(Alert, { showIcon: true, title: "Something went wrong", severity: "error" }),
        isLogsEnabled && React.createElement("h3", null, "An error ocurred. Logs are sent to application insights."),
        React.createElement("h4", null, "Please, reload to continue working:"),
        React.createElement(Button, { "aria-label": "refresh button", startIcon: React.createElement(Refresh, null), mt: 40, onClick: () => {
                navigate('/');
                window.location.reload();
            } }, "Reload")));
};
export default ErrorPage;
